import React, { useState } from 'react';
import { talentDictionary } from '../data/talentDictionary';

const PersonalityDictionaryPage = () => {
  const [isTalentDictionaryOpen, setIsTalentDictionaryOpen] = useState(true);

  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">词典中心</h1>
      <div className="max-w-4xl mx-auto">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <div 
              className="flex justify-between items-end cursor-pointer" 
              onClick={() => setIsTalentDictionaryOpen(!isTalentDictionaryOpen)}
            >
              <h2 className="text-2xl font-semibold text-gray-700 w-24 shrink-0">34才干词典</h2>
              <div className="text-sm text-gray-500 flex-1 mx-4">
                  <p>34才干的一句话解释和近义词云</p>
                  <p>近义词云根据盖洛普官方的历史调研形成，代表该才干突出的人最经常获得什么样的评价</p>
                </div>
            <svg 
              className={`w-6 h-6 transform transition-transform ${isTalentDictionaryOpen ? 'rotate-180' : ''}`}
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>

          {isTalentDictionaryOpen && (
            <div className="mt-6 space-y-6">
              {talentDictionary.map((talent, index) => (
                <div key={index} className="p-4 border border-gray-200 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-800">{talent.name}</h3>
                  <p className="text-gray-600 my-2">{talent.description}</p>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {talent.keywords.map((keyword, kwIndex) => (
                      <span key={kwIndex} className="bg-yellow-50 text-gray-700 text-sm font-medium mr-2 px-2.5 py-0.5 rounded-full">
                        {keyword}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {/* 这里可以为未来其他测评框架的词典留出位置 */}
      </div>
    </div>
  );
};

export default PersonalityDictionaryPage;